let Form = require('./form');
let Maps = require('./maps');
let Utils = require('./utils');
let Analytics = require('./analytics');
let Components = require('./components');

const Tortilla = {
  Form,
  Maps,
  Analytics,
  Components,
  Xhr: new Utils.Xhr()
};

module.exports = Tortilla;



// WEBPACK FOOTER //
// ./node_modules/tortilla/src/tortilla.js